<!--
  A given selector (including the unnamed catch-all) may only be claimed by ONE
  <ng-content> in this template: Angular resolves unmatched nodes to the LAST
  wildcard <ng-content> in template order, independent of which @if/@else branch
  actually renders. Two bare <ng-content> below (one per branch) would silently
  drop the default content whenever the *other* branch is the one that renders.
  So it gets a single <ng-content>, captured once here and replayed into
  whichever branch is active via ngTemplateOutlet.
-->
<ng-template #defaultContent>
  <ng-content></ng-content>
</ng-template>

<div
  class="tw-relative tw-flex tw-w-full tw-min-w-0 tw-cursor-pointer tw-items-center tw-gap-4 tw-p-2 md:tw-p-2"
  [ngClass]="storageLayout() ? 'tw-justify-center' : 'tw-justify-between'"
  (click)="onClick.emit()"
>
  @if (!storageLayout()) {
    @if (stackLayout()) {
      <div class="tw-flex tw-flex-1 tw-items-start tw-min-w-0 md:tw-flex-col">
        <div class="tw-flex tw-items-center tw-gap-4 tw-flex-shrink-0 tw-pt-0.5">
          <icon [name]="iconName()" [size]="16" [currentColor]="'neutral-600'"></icon>
        </div>

        <div class="tw-flex tw-flex-col tw-justify-center tw-pt-2 tw-min-w-0 md:tw-ml-2 tw-w-full">
          <div
            class="tw-text-base tw-font-medium tw-text-color-text-default tw-max-w-full tw-break-words"
          >
            {{ title() }}
          </div>

          <div class="tw-w-full tw-min-w-0 tw-mt-1">
            <ng-content select="[advanced-content]"></ng-content>
            <ng-container *ngTemplateOutlet="defaultContent"></ng-container>
          </div>
        </div>
      </div>
    } @else {
      <div class="tw-flex tw-flex-1 tw-items-center tw-min-w-0">
        <div class="tw-flex tw-items-center tw-gap-4 tw-flex-shrink-0">
          <icon [name]="iconName()" [size]="16" [currentColor]="'neutral-600'"></icon>
        </div>

        <div class="tw-flex tw-flex-col tw-items-start tw-min-w-0 md:tw-ml-2">
          <div class="tw-flex tw-items-center tw-gap-2 tw-flex-wrap tw-w-full">
            <div
              class="tw-text-base tw-font-medium tw-truncate tw-max-w-full md:tw-whitespace-nowrap"
            >
              {{ title() }}
            </div>
            <ng-content select="[badge-content]"></ng-content>
          </div>

          <div class="tw-flex tw-flex-col tw-gap-1 tw-w-full tw-min-w-0">
            <ng-container *ngTemplateOutlet="defaultContent"></ng-container>
          </div>
        </div>
      </div>
    }
  } @else {
    <div class="tw-flex tw-flex-col tw-gap-1 tw-w-full tw-min-w-0">
      <ng-content select="[storage-content]"></ng-content>
    </div>
  }

  @if (showToggle()) {
    <div class="tw-flex-shrink-0 md:tw-relative md:tw-ml-0" (click)="$event.stopPropagation()">
      <toggle-switch
        [isEnabled]="toggleEnabled()"
        [ariaLabel]="title()"
        (onClick)="toggleChange.emit($event)"
      ></toggle-switch>
    </div>
  } @else if (!storageLayout()) {
    <div
      class="tw-flex-shrink-0 md:tw-relative md:tw-ml-0"
      [ngClass]="{ 'md:tw-hidden': stackLayout() }"
    >
      <icon [name]="'right-arrow'" [size]="7" [currentColor]="'neutral-800'"></icon>
    </div>
  }
</div>
